// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1nre5","large":"styles_large__3gjXT"};